const ITEMS = [
  'FREE FOR 10K EMAILS', '•', 'LANDS IN INBOX NOT SPAM', '•', 'AUTO IP WARMING', '•',
  'WE OWN THE SERVERS', '•', 'DELIVERED IN UNDER 2 SECONDS', '•', 'NO SURPRISE OVERAGES', '•',
  'HALF THE PRICE OF RESEND', '•', 'SLACK ALERTS WHEN THINGS BREAK', '•',
]

export function MarqueeStrip() {
  const repeated = [...ITEMS, ...ITEMS, ...ITEMS]

  return (
    <div
      aria-hidden="true"
      style={{
        overflow: 'hidden',
        padding: '18px 0',
        background: '#FF6B00',
        color: '#fff',
        transform: 'rotate(-1deg) scale(1.02)',
        marginTop: -20,
        position: 'relative',
        zIndex: 5,
      }}
    >
      <div
        style={{
          display: 'flex',
          gap: 24,
          animation: 'oe-marquee 30s linear infinite',
          whiteSpace: 'nowrap',
          fontFamily: "var(--oe-font-sans)",
          fontSize: 14,
          fontWeight: 700,
          letterSpacing: '0.06em',
        }}
      >
        {repeated.map((item, i) => (
          <span key={i}>{item}</span>
        ))}
      </div>
    </div>
  )
}
